import { useCallback, useContext, useEffect, useState } from 'react';
import { Tabs } from '@hdi-seguros/web-components.tabs';

import { StepThreeFormContext } from '../../contexts';

import {
  GenericDataFormContext,
  QUOTATION_BUTTON,
  QuotationInfoContext,
  QuotationStep,
  QuotationStepButtons,
} from '../../../../../shared';

import {
  generateInputID,
  getCoverageAndActivityKeyByID,
} from '../../../../../AP/Steps/StepThree/components/Quotation/utils';
import { PersonalEffectsPaymentMethods } from '../PaymentMethods';
import { Form } from '../../../../../../../../../shared/components';

import { Summary } from '../Summary';

export const PersonalEffectsQuotation = () => {
  const {
    labelButton,
    setLabelButton,
    stepThreePersonalEffectsQuotationForm,
    quotationResponse,
    clearPrimaFieldsOnFormChange,
    createTabs,
    quotationTabs,
    handlerOnClick,
  } = useContext(StepThreeFormContext);
  const { setCurrentStep } = useContext(QuotationInfoContext);

  const { allCoveragesPerPlan } = useContext(GenericDataFormContext);

  const [activeTab, setActiveTab] = useState(quotationTabs[0]?.key);

  const handlePressTab = (activeTab: string) => setActiveTab(activeTab);

  const onPressBackButton = useCallback(async () => {
    if (quotationResponse) setLabelButton(QUOTATION_BUTTON.RECOTIZAR);
    setCurrentStep(QuotationStep.TWO);
  }, [quotationResponse, setLabelButton, setCurrentStep]);

  const onChangeForm = useCallback(
    (changedFields: any[]) => {
      if (quotationResponse) {
        setLabelButton(QUOTATION_BUTTON.RECOTIZAR);
        clearPrimaFieldsOnFormChange();
      }

      const nameOfFieldChanged: string = changedFields[0].name[0];
      const valueChanged = changedFields[0].value;

      const { activityKey, id } =
        getCoverageAndActivityKeyByID(nameOfFieldChanged);

      const tabKey = activityKey.split('-')[2];

      const planSelected = stepThreePersonalEffectsQuotationForm.getFieldValue(
        `plan-tab-${tabKey}`
      );

      const allCoveragesByTab = allCoveragesPerPlan.find(
        (el) => (el.plan as string) === String(planSelected)
      )?.coverages;

      //* Verifico si la cobertura que modifique es alguna de las que dependen otras..
      const coverageCode = allCoveragesByTab?.find(
        (el) => el.id === id
      )?.codigo;

      if (coverageCode) {
        //* Tengo que verificar ahora si en las coberturas disponibles, alguna de ellas tiene relacion con este coverageCode.
        const relatedCoverages = allCoveragesByTab?.filter(
          (el) => el.codigoCoberturaRelacionada === coverageCode
        );

        //* Ahora tendria que setear en el formulario correspondiente, es decir, cada cobertura en la actividad correspondiente.
        relatedCoverages.forEach(({ id, porcentajeSumaAsegegurada }) => {
          const checkboxName = generateInputID(id, activityKey, 'checkbox');
          if (
            stepThreePersonalEffectsQuotationForm.getFieldValue(checkboxName)
          ) {
            const inputName = generateInputID(id, activityKey);
            stepThreePersonalEffectsQuotationForm.setFieldValue(
              inputName,
              Math.round(
                valueChanged * (Number(porcentajeSumaAsegegurada) / 100)
              )
            );
          }
        });
      }
    },
    [
      setLabelButton,
      allCoveragesPerPlan,
      stepThreePersonalEffectsQuotationForm,
      quotationResponse,
      clearPrimaFieldsOnFormChange,
    ]
  );

  useEffect(() => {
    createTabs();
  }, [createTabs]);

  return (
    <div>
      <Form
        formProps={{
          form: stepThreePersonalEffectsQuotationForm,
          name: 'quotation-personal-effects-tab-form',
          onFieldsChange: onChangeForm,
        }}
      >
        <Tabs
          handlePressTab={handlePressTab}
          activeKey={activeTab}
          items={quotationTabs}
        />
      </Form>

      {quotationResponse ? (
        <>
          <PersonalEffectsPaymentMethods />

          <Summary />
        </>
      ) : (
        <></>
      )}

      <QuotationStepButtons
        label={labelButton}
        onClick={handlerOnClick}
        onPressBackButton={onPressBackButton}
      />
    </div>
  );
};
